export const enum ChatType {
  SEARCH,
  SPACE,
  AI_MODAL,
}
